import { getAdminEmails, validatedEnv } from './env';

/**
 * Admin Utility
 * Kontrola admin práv a admin email
 */

// No hardcoded emails. Admin access is configured exclusively via the
// VITE_ADMIN_EMAILS environment variable (Cloudflare Pages → Settings → Environment variables).
// To recover access if the variable is missing, set it in the Cloudflare Pages dashboard.

/**
 * Získať / Skontrolovať, či je používateľ admin
 * Accepts direct email string (fallback/legacy) or an object with an explicitly evaluated backend isAdmin flag.
 */
export const isAdmin = (userOrEmail: { email?: string, isAdmin?: boolean } | string | null | undefined): boolean => {
  if (!userOrEmail) return false;
  
  if (typeof userOrEmail === 'object' && userOrEmail.isAdmin === true) {
      return true; // Trust backend evaluated explicit flag
  }
  
  const email = typeof userOrEmail === 'object' ? userOrEmail.email : userOrEmail;
  if (!email) return false;

  const normalizedEmail = email.toLowerCase();
  const adminEmails = getAdminEmails();

  if (adminEmails.length > 0) {
    return adminEmails.includes(normalizedEmail);
  }

  // No VITE_ADMIN_EMAILS configured — deny by default and warn.
  if (validatedEnv.DEV) {
    console.warn(
      '[admin] VITE_ADMIN_EMAILS is not set. Admin access is denied. ' +
      'Set it in your .env.local or Cloudflare Pages environment variables.'
    );
  }
  return false;
};

/**
 * Získať admin práva pre používateľa
 */
export const getAdminPermissions = (email: string | null | undefined) => {
  if (!isAdmin(email)) {
    return {
      canDeleteListings: false,
      canEditListings: false,
      canManageUsers: false,
      canViewStats: false,
      canManageCategories: false,
    };
  }

  return {
    canDeleteListings: true,
    canEditListings: true,
    canManageUsers: true,
    canViewStats: true,
    canManageCategories: true,
  };
};
